var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 57,
    viewBox: "0 0 30 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9221 41.3789H18.1253V40.1206H18.9221C20.5816 40.1206 22.1712 40.7809 23.3436 41.9533L27.0155 45.6252C28.1252 46.7349 28.7544 48.2464 28.7544 49.8201C28.7544 53.0973 26.0977 55.7539 22.8206 55.7539C21.2468 55.7539 19.7354 55.1247 18.6257 54.015L14.9538 50.3431C13.7814 49.1707 13.1211 47.5811 13.1211 45.9216V45.1248H14.3794V45.9216C14.3794 47.2466 14.9066 48.5163 15.8436 49.4533L19.5155 53.1252C20.3901 53.9998 21.5818 54.4956 22.8206 54.4956C25.4028 54.4956 27.4961 52.4023 27.4961 49.8201C27.4961 48.5813 27.0003 47.3896 26.1257 46.515L22.4538 42.8431C21.5168 41.9061 20.247 41.3789 18.9221 41.3789Z",
    fill: "#25272B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24609 34.1795C1.24609 30.9023 3.90278 28.2456 7.17995 28.2456C8.75368 28.2456 10.2651 28.8748 11.3748 29.9846L15.0467 33.6564C16.2191 34.8288 16.8794 36.4184 16.8794 38.0779V38.8748H15.6211V38.0779C15.6211 36.753 15.0939 35.4832 14.1569 34.5462L10.4851 30.8743C9.61043 29.9997 8.41872 29.5039 7.17995 29.5039C4.59774 29.5039 2.50443 31.5973 2.50443 34.1795C2.50443 35.4182 3.0002 36.6099 3.87484 37.4846L7.54671 41.1564C8.4837 42.0934 9.75347 42.6206 11.0784 42.6206H11.8753V43.8789H11.0784C9.41893 43.8789 7.82933 43.2186 6.65693 42.0462L2.98506 38.3743C1.87532 37.2646 1.24609 35.7532 1.24609 34.1795Z",
    fill: "#25272B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6945 36.8052L20.1945 46.3052L19.3047 47.195L9.80469 37.695L10.6945 36.8052Z",
    fill: "#25272B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link.fc1144f99337cb7be09816609476af9b.svg";